import React from 'react';
import { BrokerCard } from '../Referal/BrokerCard';
import infoIcon from '../../assets/Refer/information1.svg';

const BrokerList = ({ brokersList }) => {
  return (
    <div className='container mx-auto'>
      <div className=' dematicons'>
        <div className='row paddingzero'>
          {Object.keys(brokersList).map((broker) => {
            return <BrokerCard broker={brokersList[broker]}></BrokerCard>;
          })}
        </div>
      </div>
      <div className='headerName'>
        <h6 className='bodyDescription'>
          <img src={infoIcon} alt={'info icon'} />
          General Terms and Conditions:
        </h6>

        <h6 className='bodyDescriptionText'>
          1. I/We hereby agree that I/we will abide by all the terms and
          conditions of Kfintech
        </h6>
        <h6 className='bodyDescriptionText'>
          2. I/We hereby agree and confirm that for each referral being made by
          me, KFintech shall make the payment as per the broking firm for whom
          the account is opened on a monthly basis to me/us, wherein KFintech
          reserves the full right to revise the payment as and when required.
        </h6>
        <h6 className='bodyDescriptionText'>
          3. I/We hereby agree, acknowledges, and understand that the role of
          KFintech shall be limited only to aggregation platform and does not
          extends to services of DP
        </h6>
        <h6 className='bodyDescriptionText'>
          4. Referral Bonus amount will be credited to the user's digital 
          card after his/her referee's account is activated
           [Account activation: Minimum value of first trade transaction is Rs 20,000]
        </h6>
        <h6 className='bodyDescriptionText'>
          5. I/We hereby agree that KFintech shall not be liable for any loss
          that may arise from any financial transactions
        </h6>
        <h6 className='bodyDescriptionText'>
          6. KFintech or its employees/directors /agents/affiliates/subsidiaries
          shall/ does not advise for any kind of investments in IPO and are not
          liable or responsible for any kind of investments made by the user
        </h6>
        <h6 className='bodyDescriptionText'>
          7. I/We hereby agree that KFintech shall not be responsible if the
          performance of its obligations is prevented, hindered, or delayed by a
          Force Majeure event. “Force Majeure Event” means any event due to any
          cause beyond the reasonable control of KFintech, including, without
          limitation, unavailability of any communication system including the
          failure of internet links, Exchange links, sabotage, fire, flood,
          explosion, earthquake, acts of God, civil commotion, pandemic,
          epidemic, strikes or industrial action of any kind, riots,
          insurrection, war, or acts of government/regulatory bodies.
        </h6>
        <h6 className='bodyDescriptionText'>
          8. All disputes and differences arising out of, under, or in
          connection with these terms and conditions or anything done hereunder
          shall be within the exclusive jurisdiction only to the courts of
          Hyderabad, State of Telangana, India.
        </h6>
        <h6 className='bodyDescriptionText'>
          I/We have fully read, understood, agree, and accept the terms and
          conditions related to the referral program and do hereby agree not to
          question the validity, enforceability, and applicability of any
          provision/clauses of this document under any circumstances whatsoever.
        </h6>
      </div>
    </div>
  );
};

export default BrokerList;